import { Controller } from "@hotwired/stimulus"

// Header roll-up of the settings autosave state. Subscribes to the window
// events the settings-autosave controller dispatches and rolls many in-flight
// field saves into one status:
//   • any save in flight        → spinner + "Saving…"
//   • count falls back to zero   → green dot + "All changes saved" (~2s flash)
//   • at rest                    → faint dot + "Saved automatically"
export default class extends Controller {
  static targets = ["indicator", "label"]

  connect() {
    this.active = 0
    this.flashTimer = null
    this.boundBegin = () => this.begin()
    this.boundEnd = () => this.end()
    window.addEventListener("settings:save-begin", this.boundBegin)
    window.addEventListener("settings:save-end", this.boundEnd)
  }

  disconnect() {
    window.removeEventListener("settings:save-begin", this.boundBegin)
    window.removeEventListener("settings:save-end", this.boundEnd)
    if (this.flashTimer) clearTimeout(this.flashTimer)
  }

  begin() {
    this.active += 1
    this.render("saving")
  }

  end() {
    this.active = Math.max(0, this.active - 1)
    if (this.active === 0) {
      this.render("saved")
      if (this.flashTimer) clearTimeout(this.flashTimer)
      this.flashTimer = setTimeout(() => this.render("idle"), 2000)
    }
  }

  render(state) {
    if (!this.hasIndicatorTarget || !this.hasLabelTarget) return
    if (state === "saving") {
      this.indicatorTarget.innerHTML = SPINNER
      this.labelTarget.textContent = "Saving…"
      this.labelTarget.className = "text-app-text-secondary"
    } else if (state === "saved") {
      this.indicatorTarget.innerHTML = `<span class="h-1.5 w-1.5 rounded-full bg-live"></span>`
      this.labelTarget.textContent = "All changes saved"
      this.labelTarget.className = "text-live"
    } else {
      this.indicatorTarget.innerHTML = `<span class="h-1.5 w-1.5 rounded-full bg-app-text-faint/50"></span>`
      this.labelTarget.textContent = "Saved automatically"
      this.labelTarget.className = "text-app-text-muted"
    }
  }
}

const SPINNER = `<svg viewBox="0 0 24 24" fill="none" class="w-3.5 h-3.5 animate-spin text-app-text-faint"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-opacity="0.25" stroke-width="3"/><path d="M21 12a9 9 0 0 0-9-9" stroke="currentColor" stroke-width="3" stroke-linecap="round"/></svg>`
